import { Component, inject, model } from '@angular/core';
import { AdvertisingFormComponent } from '../advertising-form/advertising-form.component';
import { ActivatedRoute } from '@angular/router';
import { AdvertisingService } from '../services/advertising.service';
import { AccessService } from '../../core/services/access.service';
import { AdvertisingModel } from '../../shared/models/advertising.model';
import { Advertising } from '../models/advertising.model';
import { AdvertisingInterface } from '../interfaces/advertising.interface';

@Component({
  selector: 'app-advertising-delete',
  standalone: true,
  imports: [AdvertisingFormComponent],
  templateUrl: './advertising-delete.component.html',
  styleUrl: './advertising-delete.component.css',
})
export class AdvertisingDeleteComponent {
  private route = inject(ActivatedRoute);
  private service = inject(AdvertisingService);

  protected access = inject(AccessService).access;
  protected id!: string | null;

  value = model<Advertising>();
  constructor() {}
  ngOnInit(): void {
    this.service.title.update((value) => 'Pantalla Eliminada');
    this.route.paramMap.subscribe((params) => {
      this.id = params.get('id');
      this.service.delete(params.get('id')).subscribe((data) => {
        this.value.update((value) => {
          value = new Advertising(data.data as AdvertisingInterface);
          return value;
        });
      });
    });
  }
}
